<template>
  <div role="status">
    <svg width="100" height="100" viewBox="0 0 37 21" fill="none" xmlns="http://www.w3.org/2000/svg" class="animate-pulse">
      <path
        d="M17.2261 17.502C17.2291 17.265 17.1181 17.016 16.9441 16.854L12.7231 13.176C12.7231 13.176 11.6671 12.303 11.6671 10.611C11.6731 8.58599 13.3381 6.93299 15.3991 6.90899H30.3301L36.2401 1.21499C36.6451 0.824991 36.3691 0.140991 35.8081 0.140991H14.9311C14.2921 0.140991 13.6801 0.386991 13.2211 0.830991L1.64107 11.979C-1.34093 14.85 0.00906534 19.593 3.51907 20.835L16.6261 18.342C17.0641 18.171 17.2141 17.922 17.2231 17.502H17.2261Z"
        fill="#2563EB"
      />
    </svg>
    <svg width="100" height="100" viewBox="0 0 37 21" fill="none" xmlns="http://www.w3.org/2000/svg" class="animate-pulse -mt-16 ml-2">
      <path
        d="M20.0412 3.453C20.0382 3.69 20.1492 3.939 20.3232 4.101L24.5442 7.779C24.5442 7.779 25.6002 8.65201 25.6002 10.344C25.5942 12.369 23.9292 14.022 21.8682 14.046H6.93717L1.02717 19.734C0.622173 20.124 0.898173 20.808 1.45917 20.808H22.3392C22.9782 20.808 23.5902 20.562 24.0492 20.118L35.6262 8.973C38.6082 6.102 37.2582 1.356 33.7482 0.117004L20.6412 2.61C20.2032 2.781 20.0532 3.03 20.0442 3.45L20.0412 3.453Z"
        fill="#1E3A8A"
      />
    </svg>
  </div>
</template>
